<template>
	<div class="single-car" :class="{ 'single-car--home': home, 'single-car--white': whiteCard }" @click="chooseCar">
		<div class="single-car__top">
			<!-- <ReservationPointsPerPrice
				:price="
					car.segment?.promotionalPrice?.loyaltyPoints
						? car.segment?.promotionalPrice?.loyaltyPoints
						: car.segment?.regularPrice?.loyaltyPoints
							? car.segment?.regularPrice?.loyaltyPoints
							: 0
				"
				actualPoints /> -->
			<div class="single-car__title-container">
				<div class="single-car__title">{{ car?.brand }} {{ car?.name }}</div>
				<div class="single-car__desc" :class="{ 'single-car__desc--fixed-height': home }">
					<span
						>{{ $t('modules.cars_module.single_car.or_similar') }}
						<!-- {{ i18nService.$tDynamic('pages.panel.discount_codes.code_id.segments', segmentsMapTranslations[car?.segment.name]) }} -->
						{{ locale === 'pl' ? car?.segment?.name : car?.segment?.nameEN }}
					</span>

					<div class="single-car__tooltip">
						<CarsSingleCarSegmentTooltip v-model="tooltip" :segment="car.segment.name" :segmentID="car.segment.id" />
					</div>
				</div>
			</div>
			<div v-if="!home" class="single-car__car-info-badges">
				<GlobalCarParameter
					v-for="(param, i) in filteredParametersByBags(car.parameters)"
					:key="i"
					:isElectric="isElectricCar"
					:parameter="param" />
			</div>
		</div>
		<div class="single-car__img-container">
			<GlobalImage
				v-if="car?.image"
				class="single-car__img"
				:class="{ 'single-car__img--home': home }"
				:alt="`${car?.brand} ${car?.name}`"
				:src="car?.image" />
			<GlobalImage v-else class="single-car__img" :alt="`${car?.brand} ${car?.name}`" src="car-placeholder.png" />
		</div>

		<div class="single-car__bottom">
			<div v-if="!home" class="single-car__info-badges">
				<GlobalRentParameter v-for="(param, i) in rentParameters" :key="i" :rentParameter="param" />
			</div>
			<div v-else class="single-car__car-info-badges" :class="{ 'single-car__car-info-badges--fixed-height': home }">
				<GlobalCarParameter
					v-for="(param, i) in filteredParametersByBags(car.parameters)"
					:key="i"
					:isElectric="isElectricCar"
					:parameter="param" />
			</div>
			<div class="single-car__summary">
				<!-- Regular price -->
				<div v-if="!car.segment.promotionalPrice && car.segment.regularPrice?.amountGross" class="single-car__price-container">
					<div v-if="car.segment && car.segment.regularPrice.amountGross && !home" class="single-car__main-price">
						{{
							formatPrice(
								bookingStore.getDays
									? Number(car.segment.regularPrice.amountGross) * bookingStore.getDays
									: car.segment.regularPrice.amountGross,
								2,
								true,
								car.segment.regularPrice.currency,
							)
						}}
						<span>
							/{{ $t('common.for') }} {{ bookingStore.getDays ? bookingStore.getDays : 1 }}
							<span v-if="(bookingStore.getDays && bookingStore.getDays === 1) || !bookingStore.getDays">{{ $t('common.day') }}</span>
							<span v-else>{{ $t('common.days') }}</span>
						</span>
					</div>
					<div v-else-if="car.segment && car.segment.regularPrice.amountGross" class="single-car__main-price">
						{{ formatPrice(car.segment.regularPrice.amountGross, 2, true, car.segment.regularPrice.currency) }}
						<span>/{{ $t('common.for') }} {{ $t('common.day') }}</span>
					</div>
				</div>
				<!-- Discount price -->
				<div v-else-if="car.segment.regularPrice?.amountGross" class="single-car__price-container">
					<div class="single-car__price-discount">
						<div v-if="!home" class="single-car__price-discount-old">
							{{
								formatPrice(
									bookingStore.getDays
										? Number(car.segment.regularPrice.amountGross) * bookingStore.getDays
										: car.segment?.regularPrice.amountGross,
									2,
									true,
									car.segment.regularPrice.currency,
								)
							}}
						</div>
						<div v-else class="single-car__price-discount-old">
							{{ formatPrice(car.segment.regularPrice.amountGross, 2, true, car.segment.regularPrice.currency) }}
						</div>
						<!-- <div class="single-car__price-discount-value">-200 zł</div> -->
					</div>
					<div v-if="car.segment && car.segment.promotionalPrice?.amountGross && !home" class="single-car__main-price">
						{{
							formatPrice(
								bookingStore.getDays
									? Number(car.segment.promotionalPrice.amountGross) * bookingStore.getDays
									: car.segment.promotionalPrice.amountGross,
								2,
								true,
								car.segment.promotionalPrice.currency,
							)
						}}
						<span>
							/{{ $t('common.for') }} {{ bookingStore.getDays ? bookingStore.getDays : 1 }}
							<span v-if="(bookingStore.getDays && bookingStore.getDays === 1) || !bookingStore.getDays">{{ $t('common.day') }}</span>
							<span v-else>{{ $t('common.days') }}</span>
						</span>
					</div>
					<div v-else-if="car.segment && car.segment.promotionalPrice?.amountGross" class="single-car__main-price">
						{{ formatPrice(car.segment.promotionalPrice.amountGross, 2, true, car.segment.promotionalPrice.currency) }}
						<span>/{{ $t('common.for') }} {{ $t('common.day') }}</span>
					</div>
				</div>
				<ButtonPrimary class="single-car__button">{{ $t('common.select') }}</ButtonPrimary>
			</div>
		</div>
	</div>
	<CarInquiryModal v-if="modalForm" v-model="openModal" :car="car" :min-months="minMonths" :max-months="maxMonths" />
</template>

<script setup lang="ts">
import { differenceInHours } from 'date-fns'

const router = useRouter()
const bookingStore = useBookingStore()
const props = defineProps<{
	car: IProductModel
	home?: boolean
	whiteCard?: boolean
	modalForm?: boolean
	minMonths?: number
	maxMonths?: number
	index: number
	noBooker?: boolean
}>()
const bookerStore = useBookerStore()
const bookerState = bookerStore.getBooker() as IBookerState
const bookerStartLocation = computed(() => bookerStore.getBookerStartLocation)
const $t = useI18n().t
// const i18nService = usei18nService()
const openModal = ref(false)
const localePath = useLocalePath()
const { locale } = useI18n()
const tooltip = ref(false)

const emit = defineEmits<{
	(e: 'closeMegaMenu'): void
}>()

function handleOpenModal() {
	openModal.value = true
}

const changeTooltip = (val: boolean) => {
	tooltip.value = val
}

defineExpose<{
	changeTooltip: (val: boolean) => void
}>({ changeTooltip })

const terminalOrTrainStation = computed(() => {
	if (bookerStartLocation.value?.icon === 'train') {
		return $t('modules.cars_module.single_car.on_train_station')
	} else if (bookerStartLocation.value?.icon === 'airplane') {
		return $t('modules.cars_module.single_car.on_airport')
	} else {
		return false
	}
})

const rentDeposit = props.car.parameters.find((p) => p.name === 'Deposit')
const isElectricCar = props.car.parameters.find((p) => p.name === 'Fuel Type')?.value === 'Elektryczny'

const rentParameters = ref([
	{
		title: rentDeposit
			? `${$t('modules.cars_module.cars.single_car.deposit')} ${formatPrice(rentDeposit.value, 0)}`
			: $t('modules.cars_module.cars.single_car.no_deposit'),
		tooltip: null,
		value: locale.value === 'pl' || !!(rentDeposit?.value && Number(rentDeposit.value) > 0),
	},
	{ title: $t('modules.cars_module.cars.single_car.free_cancellation'), tooltip: null, value: true },
	{
		title: `${$t('modules.cars_module.cars.single_car.collection_point_at')} ${terminalOrTrainStation.value}`,
		tooltip: `${$t('modules.cars_module.cars.single_car.collection_point_at')} ${terminalOrTrainStation.value}`,
		value: bookerStartLocation.value?.isPickupLocation && !!terminalOrTrainStation.value && bookingStore.getDays && bookingStore.getDays < 30,
	},
	{
		title: $t('modules.cars_module.cars.single_car.no_mileage_limit'),
		tooltip: null,
		value:
			!(bookerStartLocation.value?.isPickupLocation && !!terminalOrTrainStation.value) && !(bookingStore.getDays && bookingStore.getDays >= 30),
	},
	{
		title: $t('modules.cars_module.cars.single_car.mileage_limit_per_day'),
		tooltip: null,
		value: bookingStore.getDays && bookingStore.getDays >= 30,
	},
])

const assignRentParams = () => {
	rentParameters.value = [
		{
			title: rentDeposit
				? `${$t('modules.cars_module.cars.single_car.deposit')} ${formatPrice(rentDeposit.value, 0)}`
				: $t('modules.cars_module.cars.single_car.no_deposit'),
			tooltip: null,
			value: locale.value === 'pl' || !!(rentDeposit?.value && Number(rentDeposit.value) > 0),
		},
		{ title: $t('modules.cars_module.cars.single_car.free_cancellation'), tooltip: null, value: true },
		{
			title: `${$t('modules.cars_module.cars.single_car.collection_point_at')} ${terminalOrTrainStation.value}`,
			tooltip: `${$t('modules.cars_module.cars.single_car.collection_point_at')} ${terminalOrTrainStation.value}`,
			value: bookerStartLocation.value?.isPickupLocation && !!terminalOrTrainStation.value && bookingStore.getDays && bookingStore.getDays < 30,
		},
		{
			title: $t('modules.cars_module.cars.single_car.no_mileage_limit'),
			tooltip: null,
			value:
				!(bookerStartLocation.value?.isPickupLocation && !!terminalOrTrainStation.value) &&
				!(bookingStore.getDays && bookingStore.getDays >= 30),
		},
		{
			title: $t('modules.cars_module.cars.single_car.mileage_limit_per_day'),
			tooltip: null,
			value: bookingStore.getDays && bookingStore.getDays >= 30,
		},
	]
}

const isCarRentableForThisDaysCount = computed(() => {
	const startDate = bookingStore.getBookerDates?.start
	const endDate = bookingStore.getBookerDates?.end
	if (!startDate || !endDate) return true

	const minSegmentDays = props.car.segment.minDays

	const minHours = minSegmentDays ? minSegmentDays * 24 : 0

	if (!minHours) return false
	return differenceInHours(endDate, startDate) > minHours
})

watch(
	() => bookerStartLocation.value,
	() => {
		assignRentParams()
	},
	{ deep: true },
)

watch(
	() => bookingStore.getBookerDates,
	() => {
		assignRentParams()
	},
	{ immediate: true, deep: true },
)

const chooseCar = () => {
	if (props.modalForm) {
		handleOpenModal()
		return
	}
	if (props.noBooker) {
		router.push(localePath({ name: 'cars' }))
		return
	}

	emit('closeMegaMenu')
	const cookie = useCookie('cf-car')
	if (!bookingStore.getBookerLocations || bookingStore.getBookerLocations.start === null) {
		// $notyf.error('Uzupełnij miejsce odbioru/zwrotu oraz termin wypożyczenia')
		cookie.value = JSON.stringify(props.car)

		bookerState.isStartLocationMenuOpen = true
		bookerStore.setBooker(bookerState)
	} else {
		cookie.value = null

		if (!isCarRentableForThisDaysCount.value) {
			bookingStore.updateSelectedCar(props.car)
			bookerStore.setIsRedirectToReservationAfterDate(true)
			bookerStore.setIsStartDateMenuOpen(true)
			emit('closeMegaMenu')
		} else {
			bookingStore.updateSelectedCar(props.car)
			router.push(localePath({ name: 'reservation' }))
		}
	}
	sendAnalyticsData()
}

const sendAnalyticsData = () => {
	const gtmService = useGTMService()
	if (!gtmService) return
	const bookingStore = useBookingStore()
	const exchangeRate = useCookie('currency-exchange-rate')?.value ?? 1
	const GTMParameters = {
		car_name: getCarNameLabel(props.car),
		car_id: props.car.id,
		day_price: Number(getCarPricePerDay(props.car, exchangeRate)),
		total_rent: Number(getCarPrice(props.car, exchangeRate, bookingStore.getDays)),
		listing_position: props.index + 1,
		car_segment: getCarSegmentLabel(props.car),
		car_segment_id: props.car.segment.id,
		car_category: getCarGroups(props.car),
		gearbox: props.car.parameters.find((p) => p.name === 'Transmission')?.value?.toLowerCase(),
		seats: props.car.parameters.find((p) => p.name === 'Seats') ? Number(props.car.parameters.find((p) => p.name === 'Seats')?.value) : null,
		engine: props.car.parameters.find((p) => p.name === 'Fuel Type')?.value?.toLowerCase(),
	}
	gtmService.vehicleClicked(GTMParameters)
}
</script>

<style lang="scss">
@import './SingleCar';
</style>
